<template>
	
	 <div class="share">
	        <div :class="{'share-box': shareState}" @click="handleHiddenShare">
	        </div>
	        <div class="share-item" :class="{'share-show': shareState}">
	            <div class="content">
	                <div class="block">
						<span>投诉原因描述</span>
	                    <textarea class="uni-textarea-class" v-model="content" placeholder-style="color:#AAAAAA;"
	                    	placeholder="输入您的反馈详情,100字以内哦~" />
	                </div>
					<div class="block" style="margin-top:17px;">
						<span>请留下您的联系方式，以便我们和您沟通</span>
					  <input class="connect-input" placeholder-style="color:#AAAAAA;" type="text" v-model="contact"  placeholder="输入您的手机号或邮箱~" />
					</div>
	            </div>
	            <div class="cancel-default cancel"  @click="submit">
	                <span>提交</span>
	            </div>
	        </div>
	    </div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	export default {
		data(){
			return{
				isSubmit:false,
				shareState:false,
				contact:'',
				content:''
			}
		},
		methods:{
			handleHiddenShare(){
				this.shareState=false;
			},
			handleMask(){
				this.shareState=true;
			},
			getContact(e) {
				this.contact = e.detail.value.replace(/(^\s*)|(\s*$)/g, "");
				// if((/^1[34578]\d{9}$/.test(this.contact) ||
				// 	/^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/.test(
				// 		this.contact))&&this.content){
				// 			this.isSubmit=true;
				// 		}else{
				// 			this.isSubmit=false
				// 		}
			},
			getContent(e) {
				this.content = e.detail.value.replace(/(^\s*)|(\s*$)/g, "");
				// if((/^1[34578]\d{9}$/.test(this.contact) ||
				// 	/^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/.test(
				// 		this.contact))&&this.content){
				// 			this.isSubmit=true;
				// 		}else{
				// 			this.isSubmit=false
				// 		}
				
			},
			submit(){
				var obj={content:this.content,contact:this.contact}
					this.$emit('getValue',obj)
			}
		}
	}
</script>

<style scoped>
	.share {
	        /* width: 100%;
	        height: 100%; */
	    }
	    .share-box {
	        width: 100%;
	        height: 100%;
	        position: fixed;
	        top: 0px; left: 0px; bottom: 0px; right: 0px;
	        background-color: rgba(0, 0, 0, 0.4);
	        transition: .3s;
	        z-index:100;
			
			
	    }
	.share-show {
	    transition: all 0.3s ease;
	    transform: translateY(0%) !important;
	}
	
	.share-item {
	    position: fixed;
	    left: 0;
	    bottom: 0;
	    width: 100%;
	    height: auto;
	    background-color: #FFFFFF;
	    transition: all 0.3s ease;
	    transform: translateY(100%);
	    z-index: 1999;
		padding:15px 14px;
		box-sizing: border-box;
	}
	.uni-textarea-class{
		width:100%;
		background-color: #F3F3F3;
		border-radius: 4px;
		box-sizing: border-box;
		padding:12px;
		font-size: 12px;
		color: #333333;
		border: none;
			height: 130px;
	}
	.connect-input{
		background-color: #F3F3F3;
		border-radius: 4px;
		padding:12px;
		font-size: 12px;
	
		border: none;
		color: #333333;
		width: 100%;
	}
	.block>span{
		font-size: 14px;
		color: #333333;
		display: block;
		margin-bottom:12px;
		font-weight: bold;
	}
	
	.cancel-default{
		border-radius: 5px;
		font-size: 15px;
		letter-spacing: 4px;
		text-align: center;
		margin-top:20px;
		padding:11px;
		background: #F3F3F3;
		color: #AAAAAA;
	}
	.cancel{
		background: #2EC159;
		color: #FFFFFF;
	}
</style>



// WEBPACK FOOTER //
// src/view/bookComplaint/form.vue